// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-toolbar[data-v-5d2198aa]{flex-wrap:nowrap}.ui-toolbar .ui-toolbar__recorder[data-v-5d2198aa]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n", ""]);
// Exports
module.exports = exports;
